import { toast } from 'react-hot-toast'
import { userService } from '../services/UserSystem'
import { addEmailToMailingList } from '../services/mailingList.service'

export const userController = {
  getUsers,
  signup,
  login,
  loginWithGoogle,
  logout,
  resetPassword,
  sendVerificationEmail,
  updateUserProfile,
  deleteUserAccount,
  validateToken,
  loadUserById,
  loadUserByUsername,
  isEmailVerified,
  getTopEditors,
}

async function getUsers(filterBy = {}) {
  try {
    return await userService.getUsers(filterBy)
  } catch (err) {
    console.error('❌ שגיאה ב־getUsers:', err)
    throw err
  }
}

async function getTopEditors() {
  try {
    return await userService.getTopEditors()
  } catch (err) {
    console.error('❌ שגיאה ב־getTopEditors:', err)
    throw err
  }
}


// הרשמה
async function signup(userCred) {
  try {
    const user = await userService.signup(userCred)
    addEmailToMailingList(user.email)
    toast.success('הרשמה מוצלחת! אימייל אימות נשלח.')
    return user
  } catch (err) {
    toast.error('שגיאה בהרשמה: ' + err.message)
    throw err
  }
}

// התחברות רגילה
async function login(credentials) {
  try {
    const user = await userService.login(credentials)
    toast.success('התחברות מוצלחת!')
    return user
  } catch (err) {
    toast.error('שגיאה בהתחברות: ' + err.message)
    throw err
  }
}

// התחברות עם גוגל
async function loginWithGoogle() {
  try {
    const user = await userService.loginWithGoogle()
    addEmailToMailingList(user.email)
    toast.success('התחברות עם Google הצליחה!')
    return user
  } catch (err) {
    toast.error('שגיאה בהתחברות עם Google: ' + err.message)
    throw err
  }
}

// התנתקות
async function logout() {
  try {
    await userService.logout()
    toast.success('התנתקת בהצלחה!')
  } catch (err) {
    toast.error('שגיאה בהתנתקות: ' + err.message)
    throw err
  }
}

// שליחת מייל איפוס סיסמה
async function resetPassword(email) {
  try {
    await userService.resetPassword(email)
    toast.success('אימייל לאיפוס סיסמה נשלח!')
  } catch (err) {
    toast.error('שגיאה באיפוס סיסמה: ' + err.message)
    throw err
  }
}

// שליחת מייל אימות
async function sendVerificationEmail() {
  try {
    await userService.sendVerificationEmail()
    toast.success('אימייל אימות נשלח מחדש!')
  } catch (err) {
    toast.error('שגיאה בשליחת אימייל האימות: ' + err.message)
    throw err
  }
}

// עדכון פרופיל
async function updateUserProfile(updates) {
  try {
    const updatedUser = await userService.updateUserProfile(updates)
    toast.success('הפרופיל עודכן בהצלחה!')
    return updatedUser
  } catch (err) {
    toast.error('שגיאה בעדכון הפרופיל: ' + err.message)
    throw err
  }
}

// מחיקת חשבון
async function deleteUserAccount(password) {
  try {
    await userService.deleteUserAccount(password)
    toast.success('החשבון נמחק בהצלחה!')
  } catch (err) {
    toast.error('שגיאה במחיקת החשבון: ' + err.message)
    throw err
  }
}

// אימות טוקן מול השרת (בהרצה ראשונית)
async function validateToken() {
  try {
    const user = await userService.validateBackendToken()
    return user
  } catch (err) {
    return null
  }
}

// טעינת משתמש לפי ID
async function loadUserById(userId) {
  try {
    return await userService.getById(userId)
  } catch (err) {
    toast.error('שגיאה בטעינת המשתמש: ' + err.message)
    throw err
  }
}

// טעינת משתמש לפי username
async function loadUserByUsername(username) {
  try {
    return await userService.getByUsername(username)
  } catch (err) {
    toast.error('שגיאה בטעינת המשתמש לפי שם משתמש: ' + err.message)
    throw err
  }
}

// בדיקת אימות אימייל
async function isEmailVerified() {
  try {
    return await userService.isEmailVerified()
  } catch (err) {
    toast.error('שגיאה בבדיקת אימות האימייל: ' + err.message)
    throw err
  }
}
